import * as React from 'react'

function IconFile(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={57}
      height={72}
      viewBox="0 0 57 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M30.22 5.08H16.996c-3.1 0-6.072 1.225-8.264 3.408a11.614 11.614 0 00-3.423 8.23v38.644c0 3.086 1.231 6.046 3.423 8.229A11.714 11.714 0 0016.996 67H40.05c3.1 0 6.072-1.227 8.264-3.41a11.612 11.612 0 003.423-8.228V26.543a11.633 11.633 0 00-3.423-8.23l-9.85-9.81A11.712 11.712 0 0030.22 5.08v0z"
        stroke="#fff"
        strokeWidth={10}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M28.067 5.114v15.261a7.429 7.429 0 002.225 5.286 7.652 7.652 0 005.364 2.192h13.33"
        stroke="#fff"
        strokeWidth={10}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconFile
